const photographyLocations = {
  locations: [
    {
      name: 'Negril',
      locationCode: 'bng',
      country: 'jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/onsite-photos/bng-collage.jpg',
    },
    {
      name: 'Ocho Rios',
      locationCode: 'bbo',
      country: 'jamaica',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/onsite-photos/bbo-collage.jpg',
    },
    {
      name: 'Turks &amp; Caicos',
      locationCode: 'btc',
      country: 'turks &amp; caicos',
      img: 'https://cdn.sandals.com/beaches/v12/images/weddings/onsite-photos/btc-collage.jpg',
    },
  ]
};

module.exports = photographyLocations;
